import React from 'react';
import caiqueImg from '../../assets/caique.jpg';
import linkedin from '../../assets/linkedin.png';
import instagram from '../../assets/instagram.png';
import twitter from '../../assets/twitter.png';
import github from '../../assets/github.png';
import eneagrama from '../../assets/eneagrama.png';
import medium from '../../assets/medium.png';

import './styles.css'

export default function AboutCaique({history}) {

    function goToHome(){
        history.push('/home')
    }

    return (
        <div>
             <div onClick={goToHome} className='container-arrow'>
                <i className="left"></i>
                <p className='text-back'>Voltar</p>
            </div>
            <div className='name-photo-container'>
                <span className='photo-container'>
                    <img className='photo-caique' src={caiqueImg} alt="foto do desenvolvedor" />
                </span>
                <p className='user-name'> Caíque Coelho </p>
            </div>
            <p className='text-about'>
                Oriundo de Guiratinga - Mato Grosso, bacharel em Ciência da Computação pela UFMS, alumni na AIESEC Campo Grande, Analista de Qualidade de Software no QuintoAndar em São Paulo e desenvolvedor nas horas vagas!
            </p>
            <p className='text-email'>
                Contato: caiquedpfc@gmail.com
            </p>

            <div className='social-container'>
                <a href='https://www.linkedin.com/in/caiquecoelho/'>
                    <img className='social' src={linkedin} alt="Linkedin Caíque Coelho"
                    />
                </a>

                <a href='https://twitter.com/caiqueocoelho'>
                    <img className='social' src={twitter} alt="Twitter Caíque Coelho"
                    />
                </a>

                <a href='https://www.instagram.com/caiqueocoelho/'>
                    <img className='social' src={instagram} alt="Instagram Caíque Coelho"
                    />
                </a>
            </div>

            <div className='social-container'>
                <a href='https://github.com/CaiqueCoelho/'>
                    <img className='social' src={github} alt="Github Caíque Coelho"
                    />
                </a>

                <a href='https://teste-eneagrama.firebaseapp.com/'>
                    <img className='social' src={eneagrama} alt="Teste Eneagrama"
                    />
                </a>

                <a href='https://medium.com/@caiquecoelho/'>
                    <img className='social' src={medium} alt="Medium Caíque Coelho"
                    />
                </a>
            </div>
        </div>
    )
}